<script setup>
import { useCartStore } from '../stores/cartStore'
import { useRouter } from 'vue-router'

const cartStore = useCartStore()
const router = useRouter()
</script>

<template>
  <!-- Mobile Buttons -->
  <div class="card fixed-bottom d-lg-none">
    <div class="card-body p-3">
      <div class="row justify-content-between">
        <div class="d-grid col-2">
          <button
            id="nav-button-cart-help"
            class="btn btn-outline-primary cart-help-button"
            type="button"
          >
            <i class="fa-sharp fa-light fa-xl fa-comment-question"></i>
          </button>
        </div>
        <div class="d-grid col-4 col-lg-3">
          <button
            class="btn btn-soft-primary"
            type="button"
            v-if="cartStore.cartData"
            @click="cartStore.goToPreviousStep"
          >
            Previous
          </button>
        </div>
        <div class="d-grid col-6 col-lg-3">
          <button
            class="btn btn-primary"
            v-if="cartStore.cartData"
            type="submit"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Mobile Buttons -->
  <!-- Desktop Buttons -->
  <div class="card d-none d-lg-block sticky-bottom">
    <div class="card-body p-3">
      <div class="row justify-content-between">
        <div class="d-grid col-6 col-lg-3">
          <button
            class="btn btn-soft-primary"
            type="button"
            v-if="cartStore.cartData"
            @click="cartStore.goToPreviousStep"
          >
            Previous
          </button>
        </div>
        <div class="d-grid col-6 col-lg-3">
          <button
            class="btn btn-primary float-end"
            v-if="cartStore.cartData"
            type="submit"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Desktop Buttons -->
</template>
